'use client';
import React from 'react';
import Image from 'next/image';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import type { VersatileCookingItem } from '@src/domain/types/MeaterProduct';
import buildImageSrc from '@repo/ui/src/functions/image-functions-aspect-ratio';

interface VersatileCookingProps {
  items: Array<VersatileCookingItem>;
}

const VersatileCooking = ({ items }: VersatileCookingProps) => {
  const { t } = useTranslation();

  if (!items.length) return null;

  return (
    <div className="py-5 flex flex-col gap-5">
      <h5 className="tra-text-web-heading-5 text-neutral-700">
        {t('productDetailPageContent.versatileCookingHeading', undefined, {
          default: 'Versatile Cooking',
        })}
      </h5>
      <ul className="grid grid-cols-3 gap-5 list-none m-0 p-0">
        {items.map((item, idx) => (
          <li key={idx} className="flex flex-col items-center gap-3 text-center">
            <div className="w-16 h-16 relative flex-shrink-0">
              <Image
                src={buildImageSrc(item.image)}
                alt={item.image.accessibilityLabel ?? item.title}
                fill
                className="object-contain"
              />
            </div>
            <span className="tra-text-web-body-m">{item.title}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default VersatileCooking;
